import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import {
    TranslateLoader,
    TranslateModuleConfig,
} from '@ngx-translate/core';
import { TranslationService } from '@services';

export function createTranslateLoader(http: HttpClient, appState: AppStateFacade) {
    return new TranslationService(http, appState);
}

export const TRANSLATE_MODULE_CONFIG: TranslateModuleConfig = {
    loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient, AppStateFacade],
    },
};
